export default __webpack_public_path__ + "static/media/zoneIconSmart.e6e7e7a7.svg";